import { useTranslation } from 'next-i18next/pages';
import { type ParseKeys } from 'i18next';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { CheckCircle } from '@/icons/small/CheckCircle';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';

import styles from './Benefits.module.css';

const BENEFIT_NUMBERS = [1, 2, 3] as const;

export const Benefits = () => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);

  return (
    <ul className={styles.benefits} data-testid="expose-contact-form_benefits">
      {BENEFIT_NUMBERS.map((i) => {
        const translationKey = `search.contact.form.benefit${i}` as ParseKeys<'property_expose'>;

        return (
          <li className={styles.benefit} key={translationKey}>
            <CheckCircle className={styles.benefitIcon} aria-hidden="true" />
            <Copy text={t(translationKey)} size="m" />
          </li>
        );
      })}
    </ul>
  );
};
